import React from "react";
import Link from "gatsby-link";
import Img from "gatsby-image";
import graphql from "graphql";
import Helmet from 'react-helmet';

import Navbar from '../components/Navbar.js';
import { HTMLContent } from '../components/Content.js'

import logo from '../img/logo.svg';
import VolumeOnSvg from '../img/volume-on.svg';
import VolumeOffSvg from '../img/volume-off.svg';

import VimeoBackgroundCover from '../components/VimeoBackgroundCover.js';

import ScrollCascade from '../components/ScrollCascade.js';
import ScrollAnimation from 'react-animate-on-scroll';

import ProjectsPage from '../templates/projects-page.js';
import AboutPage from '../templates/about-page.js';
import ContactPage from '../templates/contact-page.js';
import { url as siteUrl } from '../../site.json';
import { isMobile, isChrome, isSafari } from 'react-device-detect';
import Vimeo from '../components/Vimeo';
import { parseVimeoUrl } from '../utils/vimeo';
import LazyLoad from 'react-lazyload';

export class IndexPage extends React.Component {

  state = {
    loading: true,
    videoPercentage: 0,
    videoIndex: 0,
    muted: true,
    mobileVisible: false,
    showMobileShowreel: false,
    mounted: false,
  }

  _onVimeoProgress = ({ percent }) => {
    this.setState({
      videoPercentage: (percent * 100)
    });
  }

  _canplay = (event, player) => {
    this.vimeoPlayer = player;
    this.setState({
      loading: false
    });
  }

  _onEnded = () => {
    const { data } = this.props;
    const { videoIndex } = this.state;
    const { frontmatter: { videos } } = data.markdownRemark;

    this.setState({
      videoIndex: videoIndex < (videos.length - 1) ? videoIndex + 1 : 0
    });
  }

  toggleVolume = () => {
    if (this.vimeoPlayer) {
      this.vimeoPlayer.getVolume().then(volume => {
        this.vimeoPlayer.setVolume(volume > 0 ? 0 : 1);
        this.setState({ muted: volume > 0 });
      });
    }
  }

  onResize = () => {
    if (this.section) {
      setTimeout(() => {
        const newHeight = document.documentElement.clientHeight;
        this.section.style.minHeight = newHeight + 'px';
      }, 100);
    }
  }

  componentWillUnmount() {
    if (this.timeoutListener) {
      clearTimeout(this.timeoutListener);
    }
    if (window) {
      window.removeEventListener('orientationchange', this.onResize);
    }
  }

  onFirstTouch = () => {
    const video = this.htmlVideoContainer.children[0];
    if (video) {
      try {
        const p = video.play().then((suc) => console.log('play', suc), (err) => console.error('play', err));
      } catch (e) {
        console.warn('couldnt autoplay video');
      }
    }
    window.removeEventListener('touchstart', this.onFirstTouch);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.htmlVideoContainer && prevState.mounted !== this.state.mounted) {
      window.addEventListener('touchstart', this.onFirstTouch);
      const video = this.htmlVideoContainer.children[0];
      video.addEventListener('loadeddata', this._canplay, false);
    }
  }

  componentDidMount() {
    if (this.section && isMobile && isChrome) {
      this.onResize();

      if (window) {
        window.addEventListener('orientationchange', this.onResize);
      }
    }

    this.setState({ mounted: true });
  }

  render() {
    const { data, location, history, links } = this.props;
    const { videoIndex, mobileVisible, showMobileShowreel } = this.state;
    const { loading, videoPercentage, mounted } = this.state;
    const { frontmatter: { title, videos, menu, image }, html, bodyWidget, fields: { imageFile } } = data.markdownRemark;

    const activeVideo = videos[videoIndex] ? videos[videoIndex] : false;

    let playerInfo = (
      <div className="home-title is-unselectable">
        <h1 className="has-text-weight-bold is-size-3 is-size-4-touch animated-step-delay am-infinite">
          <span className="animated fadeIn">LOADING</span>
          <span className="animated fadeIn">LOADING</span>
          <span className="animated fadeIn">LOADING</span>
        </h1>
      </div>
    )

    if (!loading) {
      playerInfo = (
        <div>
          <div className="is-unselectable content is-marginless" style={{ paddingBottom: '.5rem' }}>Now playing:</div>
          <div
            className="home-title is-size-3 is-size-5-touch m-uc m-b animated fadeIn"
            onClick={() => {
              if (this.timeoutListener) {
                clearTimeout(this.timeoutListener);
              }
              this._onEnded();
            }}
          >
            {activeVideo.title}
          </div>
        </div>
      )
    }

    // if (isMobile && this.state.mounted) playerInfo = null;

    if (showMobileShowreel) {
      const { url: videoCanonicalUrl } = parseVimeoUrl(activeVideo.url);
      return (
        <section className="section">
          <svg
            onClick={() => this.setState({ showMobileShowreel: false })}
            viewBox="0 0 100 100"
            className="svg-close-icon is-unselectable b-abs m-top-pad m-right-pad"
          >
            <line x1="0" y1="100"
                  x2="100" y2="0"
            />
            <line x1="0" y1="0"
                  x2="100" y2="100"
            />
          </svg>
          <div className="b-video-container is-overlay is-flex" style={{ alignItems: 'center', justifyContent: 'center' }}>
            <div className="b-video-container-169">
              <Vimeo
                url={videoCanonicalUrl}
                vimeoOptions={{ byline: false, portrait: false, title: false }}
                className="b-video-container-make-height" />
            </div>
          </div>
        </section>
      )
    }

    let backgroundCover = null;

    if (activeVideo && mounted) {
      // if (isMobile) {
      //   backgroundCover = (
      //     <div ref={(ref) => this.htmlVideoContainer = ref} dangerouslySetInnerHTML={{ __html: `
      //       <video
      //         class="${loading ? 'is-hidden' : 'animated fadeIn'}"
      //         muted
      //         autoplay
      //         loop
      //         playsinline
      //         webkit-playsinline
      //         preload="auto"
      //         src="/video/bgmutedvideo.mp4"

      //       />
      //     ` }}
      //       style={{ height: '100%' }}
      //     />
      //   )
      // } else {
        backgroundCover = (
          <VimeoBackgroundCover
            url={activeVideo.url}
            onUpdate={this._onVimeoProgress}
            onLoaded={this._canplay}
            onPlay={({ duration }) => this.timeoutListener = setTimeout(this._onEnded, duration * 1000)}
          />
        )
      // }
    } else {
      if (imageFile.childImageSharp) {
        backgroundCover = <Img sizes={imageFile.childImageSharp.sizes} outerWrapperClassName="m-fullh" style={{ height: '100%' }} />
      } else {
        backgroundCover = <LazyLoad once><img src={image} style={{ objectFit: 'cover', height: '100%' }} /></LazyLoad>
      }
    }

    return (
      <section className="section is-padding-top-4-desktop" ref={ref => this.section = ref}>
        <div className="b-video-container is-overlay">
          { backgroundCover }
        </div>
        <div className="container is-fluid is-clearfix" style={{ height: '100%' }}>
          <div className={"home-title is-pulled-left is-unselectable" + (mobileVisible ? ' is-invisible' : '')}>
            <h1 className="has-text-weight-bold is-size-3 is-size-4-touch animated-step-delay">
              <span className="animated fadeIn">{title}</span>
              <span className="animated fadeIn">{title}</span>
              <span className="animated fadeIn">{title}</span>
            </h1>
          </div>

          <Navbar menu={menu} location={location} history={history} toggleMobile={(mobileVisible) => {
            this.setState({ mobileVisible });
          }}>
            <ScrollAnimation delay={1500} offset={100} animateIn="fadeIn" animateOut="fadeOut">
              { links ?
                <div className="b-home-content m-text-white is-hidden-mobile content is-size-6-touch" style={{ marginTop: '2.5rem' }}>
                  <div>
                    Follow us on:
                    {links.map(({ text, url }) => (
                      <div key={text}><a href={url ? url : '#'} target="_blank">{text}</a></div>
                    ))}
                  </div>
                </div>
              : null }
            </ScrollAnimation>
          </Navbar>

          <div className="is-clearfix"></div>
          <div className="columns" style={{ marginTop: '2.5rem' }}>
            <div className="column is-one-third-desktop is-half-tablet">
              <div className="b-home-content content is-size-6-touch">
                { bodyWidget ? bodyWidget :
                  <ScrollAnimation delay={1500} animateIn="fadeIn" animateOut="fadeOut">
                    <HTMLContent content={html}/>
                  </ScrollAnimation>
                }
                { isMobile ?
                  <div
                    className="button is-outlined is-primary animated fadeIn"
                    style={{ marginTop: '2rem' }}
                    onClick={() => {
                      this.setState({ showMobileShowreel: true });
                    }}
                  >
                    PLAY: {activeVideo.title}
                  </div>
                : null }
              </div>
            </div>
            <div className="column"></div>
          </div>
        </div>
        <div className="b-abs m-btm m-right-pad m-btm-pad b-player-title">
          <ScrollAnimation offset={80} animateIn="fadeIn" animateOut="fadeOut">
            <div className="columns is-mobile">
              <div className="column is-narrow">
                { !loading ?
                  <img
                    onClick={this.toggleVolume}
                    src={this.state.muted ? VolumeOffSvg : VolumeOnSvg}
                    className="svg-fullscreen-icon is-hidden-touch is-inline is-pulled-left" style={{ marginRight: '2rem' }}
                  />
                : null }
              </div>
              <div className="column">
                {playerInfo}
              </div>
            </div>
          </ScrollAnimation>
        </div>
        <div className="b-abs m-btm m-left-pad m-right-pad">
          <progress className="progress b-video-progress is-small" value={videoPercentage} max="100">{videoPercentage}%</progress>
        </div>
        
      </section>
    );
  }
}

export default class CombinedPages extends React.Component {

  render() {
    const { props } = this;
    const { excerpt, frontmatter: { title }, fields: { ogImageFile } } = props.data.markdownRemark;
    let image = null;
    if (ogImageFile) {
      image = ogImageFile.childImageSharp.resize;
    }
    return (
      <div>
        <Helmet>
          <meta name="description" content={excerpt} />
          <meta property="og:title" content={title} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={siteUrl} />
          { image && image.src ?
            <meta property="og:image" content={siteUrl + image.src} />
           : null }
          { image && image.width ?
            <meta property="og:image:width" content={image.width} />
           : null }
          { image && image.height ?
            <meta property="og:image:height" content={image.height} />
           : null }
          <meta property="og:description" content={excerpt} />
        </Helmet>
        <div name="/">
          <IndexPage {...props} {...{ links: props.data.contactPage.frontmatter.links }}/>
        </div>
        <div name="/projects">
          <ProjectsPage {...props}/>
        </div>
        <div name="/about" style={{ overflow: 'hidden' }}>
          <AboutPage data={{ markdownRemark: props.data.aboutPage }} />
        </div>
        <div name="/contact">
          <ContactPage data={{ markdownRemark: props.data.contactPage }} />
        </div>
      </div>
    )
  }
}

export const fragment = graphql`
  fragment indexFragment on RootQueryType {
    markdownRemark(frontmatter: { path: { eq: "/" } }) {
      html
      excerpt
      fields {
        imageFile {
          childImageSharp {
            sizes(maxWidth: 800) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        ogImageFile {
          childImageSharp {
            resize(width: 1200, height: 630, toFormat: PNG, quality: 90) {
              src
              width
              height
            }
          }
        }
      }
      frontmatter {
        title
        image
        menu {
          title
          page
          hidden
        }
        videos {
          title
          url
        }
      }
    }
    ...projectsList
    aboutPage: markdownRemark(frontmatter: { path: { eq: "/about" } }) {
      ...aboutPage
    }
    contactPage: markdownRemark(frontmatter: { path: { eq: "/contact" } }) {
      ...contactPage
    }
  }
`

export const query = graphql`
  query IndexPage {
    ...indexFragment
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js